// if (!location.href.includes('https')) {
//   location.href = location.href.replace('http', 'https')
// }

// 获取屏幕宽度，用来判断是否“移动端访问 PC 站点”（A 规则）
let htmlWidth =
  document.documentElement.clientWidth || document.body.clientWidth;
const DeviceType = htmlWidth < 750 ? "mobile" : "pc";

// 当前项目是否为 mobile 路径（兜底判断）
const ProjectType = location.pathname.startsWith("/mobile") ? "mobile" : "pc";

// 用于本构建 history 路由（PC）跳转
function redirectTo(pathAndQuery) {
  const url = `${location.origin}${
    pathAndQuery.startsWith("/") ? "" : "/"
  }${pathAndQuery}`;
  location.href = url;
}

// PC -> mobile：仅在“移动端打开 PC 站点”时触发
if (DeviceType === "mobile" && ProjectType === "pc") {
  const pathname = location.pathname || "/";
  const searchParams = new URLSearchParams(location.search || "");

  // 把 PC history 路由名转换成 mobile hash 路由
  let mobileHash = "";
  if (pathname === "/") {
    mobileHash = "#/";
  } else if (pathname === "/oriental_express") {
    mobileHash = "#/oriental_express";
  } else if (pathname === "/articleDetails" && searchParams.has("id")) {
    const id = searchParams.get("id");
    mobileHash = `#/article?id=${encodeURIComponent(id)}`;
  } else if (
    pathname === "/latestnews" &&
    searchParams.get("module") === "latestNews"
  ) {
    mobileHash = "#/articles?contentType=1";
  } else if (
    pathname === "/clinicalPulse/list" &&
    searchParams.get("module") === "leading"
  ) {
    mobileHash = "#/articles?contentType=4";
  } else if (
    pathname === "/clinicalPulse/list" &&
    searchParams.get("module") === "medtalk"
  ) {
    mobileHash = "#/articles?contentType=3";
  } else if (
    pathname === "/people" &&
    searchParams.get("module") === "people"
  ) {
    mobileHash = "#/articles?contentType=2";
  } else if (
    pathname === "/partnership/list" &&
    searchParams.get("module") === "platform"
  ) {
    mobileHash = "#/articles?contentType=5";
  } else if (
    pathname === "/user_center" &&
    searchParams.get("type") === "1"
  ) {
    mobileHash = "#/account";
  } else if (
    pathname === "/user_center" &&
    searchParams.get("type") === "2"
  ) {
    mobileHash = "#/collection";
  }

  // 没匹配到映射时：保底把当前路径挂到 mobile hash 上
  if (!mobileHash) {
    mobileHash = `#${pathname}${location.search || ""}`;
  }

  location.href = `${location.origin}/mobile/${mobileHash}`;
} else {
  // 兼容旧入口：/articles?contentType=... -> PC 列表路由
  const pathname = location.pathname || "/";
  const searchParams = new URLSearchParams(location.search || "");
  let target = "";

  if (pathname === "/articles") {
    const contentType = searchParams.get("contentType");
    if (contentType === "1") target = "/latestnews?module=latestNews";
    if (contentType === "2") target = "/people?module=people";
    if (contentType === "3")
      target = "/clinicalPulse/list?moduleTitle=MedTalk&module=medtalk";
    if (contentType === "4")
      target = "/clinicalPulse/list?moduleTitle=&module=leading";
    if (contentType === "5")
      target = "/partnership/list?module=platform";
  }

  // 兼容旧入口：/article?id=... -> PC 文章详情
  if (!target && pathname === "/article" && searchParams.has("id")) {
    const id = searchParams.get("id");
    target = `/articleDetails?id=${encodeURIComponent(id)}`;
  }

  // 兼容旧入口：/account、/collection -> PC 用户中心
  if (!target && pathname === "/account") {
    target = "/user_center?type=1";
  }
  if (!target && pathname === "/collection") {
    target = "/user_center?type=2";
  }

  // 兼容旧入口：/oriental_express -> /
  if (!target && pathname === "/oriental_express") {
    target = "/";
  }

  if (target) {
    redirectTo(target);
  }
}
